// src/pages/Home.tsx
import React from 'react';
import WodDashboard from '../components/WodDashboard';
import { useSession } from '../../core/context/SessionContext';
import { useLiveSession } from '../../core/hooks/useLiveSession';
import ErrorPage from './ErrorPageProps';
import { useDataContext } from '../../core/context/DataContext';
//import { Wod } from '../../core/models/Wod';
import { filterWods } from '../../core/utils/filters';
//import DebugPanel from '../components/debug/DebugPanel';
// import Box10DebugPanel from '../components/debug/Box10DebugPanel';

const Home: React.FC = () => {
  const { sessionId: boxIdStr } = useSession();
  const boxId = Number(boxIdStr);

  // Manejo de liveSession compatible con desarrollo y producción
  const liveSessionResult = useLiveSession();

  // En desarrollo: { session, updateDebugState }
  // En producción: LiveSession | null
  const liveSession =
    liveSessionResult && typeof liveSessionResult === 'object' && 'session' in liveSessionResult
      ? liveSessionResult.session
      : liveSessionResult;

  const updateDebugState =
    liveSessionResult &&
      typeof liveSessionResult === 'object' &&
      'updateDebugState' in liveSessionResult
      ? liveSessionResult.updateDebugState
      : undefined;

  console.log('updateDebugState', updateDebugState);

  // Datos del contexto
  const { wodDelDia, loading, error, today, nowTime } = useDataContext();

  if (loading) return <div>Cargando contenido…</div>;
  if (error) return <ErrorPage code={500} message={error} />;
  if (!wodDelDia) return <ErrorPage code={404} message="No hay WOD para la fecha seleccionada" />;

  // console.log('ver lo de liveSession:', { liveSession });
  const FilterList = filterWods(wodDelDia);

  return (
    <div className="min-h-screen p-0 space-y-0">
      <WodDashboard
        boxId={boxId}
        liveSession={liveSession}
        wod={FilterList}
        date={today}
        time={nowTime}
      />

      {/* 🔧 DEBUG PANEL - Solo visible en desarrollo */}
      {/* {updateDebugState && <DebugPanel onStateChange={updateDebugState} />}   */}

      {/* 📊 BOX 10 DEBUG PANEL - Solo visible para Box 10 */}
      {/* <Box10DebugPanel boxId={boxId} /> */}
    </div>
  );
};

export default Home;
